import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import PostHeader from 'src/modules/community/singlePost/components/postHeader';
import Responses from 'src/modules/community/singlePost/components/responses';
import NextPosts from 'src/modules/community/singlePost/components/nextPosts';
import RepliesTurnedOffNotice from 'src/modules/community/singlePost/components/repliesTurnedOffNotice';
import FeaturedPosts from 'src/modules/community/singlePost/components/featuredPosts';
import GlobalSearch from 'src/modules/search/shared/components/searchBar';
import SecondPageBlockMessageBox from 'src/modules/community/singlePost/components/secondPageBlockMessageBox';
import PostActions from 'src/modules/community/singlePost/components/postActions';
import GetElement from 'src/components/getElement';
import WriteReplyBox from 'src/modules/community/singlePost/components/replies/writeReplyBox';
import { MyEditor } from 'src/components/textEditor/customHelpers';
import { scrollToElementId } from 'src/utils/scroll';
import PostTags from 'src/modules/community/singlePost/components/postTags';
import Post from 'src/modules/community/singlePost/components/post';
import { Key, getLocalStorageItem } from 'src/utils/localStorage';
import { titleMedium, textLinkPrimary, textWideSpacing } from 'styles-js/mixins/typography';
export default function PostContent() {
  const {
    post
  } = useSelector(({
    pages
  }) => pages.singlePost);
  const {
    currentCommunity,
    currentUser,
    isAndroidUser
  } = useSelector(({
    context
  }) => context);
  const isPostBlocked = useIsPostBlocked();
  const isReplyOff = post?.isLocked || currentCommunity?.isArchived;
  const respondRef = useRef(null);
  const firstReplyEditorId = `first-response-${post?.id}`;
  const focusNewReply = () => {
    scrollToElementId(firstReplyEditorId, 0);
    if (!isAndroidUser && respondRef.current) {
      MyEditor.focus(respondRef.current);
    } else {
      document.querySelector<HTMLElement>('[contenteditable=true]')?.focus();
    }
  };
  if (!post || !currentCommunity) return null;
  return <Container data-sentry-element="Container" data-sentry-component="PostContent" data-sentry-source-file="postContent.tsx">
      <PostHeader data-sentry-element="PostHeader" data-sentry-source-file="postContent.tsx" />

      {isPostBlocked ? <BlockMessageContainer>
            <PostBody className="js-post-body">
              <GetElement enrichedContent={post.enriched?.body?.slice(0, 3)} />
            </PostBody>
            <SecondPageBlockMessageBox />
          </BlockMessageContainer> : <>
            <Post />
            <PostTags />
            <PostActions onReply={focusNewReply} />
            <FeaturedPosts />

            {currentUser && !isReplyOff && <div className="post-respond" id={firstReplyEditorId}>
                <WriteReplyBox respondRef={respondRef} />
              </div>}
            {isReplyOff && <RepliesTurnedOffNotice />}

            <Responses />

            {post.responses?.length >= 3 && <>
                {currentUser && !isReplyOff && <div className="post-respond post-respond--bottom">
                    <WriteReplyBox />
                  </div>}
                {isReplyOff && <RepliesTurnedOffNotice />}
              </>}
          </>}

      {!currentUser && <>
          <H2>{i18n.t(`Not what you're looking for?`)}</H2>
          <StyledSearchBar dataTestId="search-page-bar" placeholder={i18n.t('Search our archives for advice and experiences')} />
        </>}
      <NextPosts data-sentry-element="NextPosts" data-sentry-source-file="postContent.tsx" />
    </Container>;
}
function useIsPostBlocked() {
  const isSecondPageBlockMsgBoxVisible = useSelector(({
    pages
  }) => pages.singlePost.isSecondPageBlockMsgBoxVisible);
  const [isSecondBlockVisible, setIsSecondBlockVisible] = useState(isSecondPageBlockMsgBoxVisible);
  useEffect(() => {
    setIsSecondBlockVisible(Boolean(getLocalStorageItem(Key.secondPageBlock)) || isSecondPageBlockMsgBoxVisible);
  }, [isSecondPageBlockMsgBoxVisible]);
  return isSecondBlockVisible;
}
const Container = styled.div`
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    padding: 0 15px;
    margin-bottom: 40px;
  }
`;
export const PostBody = styled.div`
  ${textWideSpacing};
  margin-bottom: 40px;
  overflow-wrap: break-word;
  a {
    ${textLinkPrimary};
  }
  & p {
    margin-bottom: 15px;
  }
`;
const BlockMessageContainer = styled.div`
  position: relative;

  ${PostBody} {
    height: 85px;
    margin-bottom: 0;
  }
`;
const H2 = styled.h2`
  ${titleMedium}
  margin-top: 30px;
`;
const StyledSearchBar = styled(GlobalSearch)`
  margin-top: 20px;
`;